import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

const PrivacyPolicy = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const isTermsOfService = location.pathname.includes('terms-of-service')

    return (
        <div className="bg-white text-black min-h-screen pt-24 pb-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto space-y-8">
                <h1 className="text-4xl font-bold mb-8">
                    {isTermsOfService ? t('privacy.tos_title') : t('privacy.title')}
                </h1>

                {/* Terms of Service Section */}
                {isTermsOfService && (
                    <>
                        <section className="space-y-4">
                            <p className="text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: t('privacy.tos_content_intro') }} />
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.content_terms')}
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-bold">{t('privacy.disclaimer_title')}</h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.disclaimer_text')}
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-bold">{t('privacy.tos_sms_program_title')}</h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.tos_sms_program_text')}
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-bold">{t('privacy.tos_optout_title')}</h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.tos_optout_text')}
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-bold">{t('privacy.tos_data_rates_title')}</h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.tos_data_rates_text')}
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-bold">{t('privacy.tos_carrier_title')}</h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.tos_carrier_text')}
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-bold">{t('privacy.tos_age_title')}</h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.tos_age_text')}
                            </p>
                        </section>
                    </>
                )}

                {/* Privacy Policy Section */}
                {!isTermsOfService && (
                    <>
                        <section className="space-y-4">
                            <p className="text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: t('privacy.content_intro') }} />
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.content_terms')}
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-bold">{t('privacy.disclaimer_title')}</h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.disclaimer_text')}
                            </p>
                        </section>
                    </>
                )}

                {/* SMS Opt-In Details — shown on Privacy Policy only */}
                {!isTermsOfService && (
                    <>
                        <section className="space-y-4">
                            <h2 className="text-2xl font-bold">{t('privacy.sms_optin_title')}</h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.sms_optin_text')}
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-bold">{t('privacy.user_rights_title')}</h2>
                            <p className="text-gray-700 leading-relaxed">
                                {t('privacy.user_rights_text')}
                            </p>
                        </section>
                    </>
                )}

                {/* Shared sections for both */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t('privacy.privacy_important_title')}</h2>
                    <p className="text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: t('privacy.privacy_important_text1') }} />
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.privacy_important_text2')}
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t('privacy.visitors_title')}</h2>
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.visitors_text')}
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t('privacy.gathering_title')}</h2>
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.gathering_text')}
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t('privacy.security_title')}</h2>
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.security_text')}
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t('privacy.links_title')}</h2>
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.links_text')}
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t('privacy.stats_title')}</h2>
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.stats_text')}
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t('privacy.cookies_title')}</h2>
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.cookies_text')}
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t('privacy.mobile_title')}</h2>
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.mobile_text')}
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">{t('privacy.clarity_title')}</h2>
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.clarity_text')}
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl font-bold">
                        {isTermsOfService ? t('privacy.changes_tos_title') : t('privacy.changes_title')}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                        {t('privacy.changes_text')}
                    </p>
                </section>
            </div>
        </div>
    )
}

export default PrivacyPolicy
